module.exports = __webpack_public_path__ + "assets-customer/images/womens-category.png?40b87f25";